import './ClassProductsModal.scss'

import { DeleteFilled } from '@ant-design/icons'
import { Divider, Modal } from 'antd'
import { Button, Col, Input, message, Row } from 'antd'
import { SecilenUrun } from 'pages/class-products/ClassProductsPage'
import { useEffect, useState } from 'react'
import { ETIKET_URUN_ID } from 'utils/const'

import useRemainingChars from '../class-products-table/useRemainingChars'
import defterImg from './images/Defter.png'
import { ReactComponent as PinIcon } from './images/pin.svg'
interface ClassProductsTableProps {
  modelVisible: any
  setModalVisible: any
  setSelectedProducts: any
  selectedProducts: SecilenUrun[]
}

const ClassProductsModal = ({
  modelVisible,
  setModalVisible,
  setSelectedProducts,
  selectedProducts,
}: ClassProductsTableProps) => {
  const [studentName, setStudentName, remainingCharsName] = useRemainingChars('')
  const [studentSurname, setStudentSurname, remainingCharsSurname] = useRemainingChars('')
  const [studentClass, setStudentClass] = useState('')
  const [studentNumber, setStudentNumber] = useState('')
  const [messageApi, contextHolder] = message.useMessage()
  const MAX_LENGTH = 30
  const etiketUrunId = ETIKET_URUN_ID

  useEffect(() => {
    if (!modelVisible) return
    const etiket = selectedProducts.find((row: SecilenUrun) => row.urunId === etiketUrunId)
    if (etiket?.etiket_bilgisi) {
      const [ad, soyad, numara, sinif] = etiket.etiket_bilgisi.split('|')
      setStudentName(ad ?? '')
      setStudentSurname(soyad ?? '')
      setStudentNumber(numara ?? '')
      setStudentClass(sinif ?? '')
    } else {
      setStudentName('')
      setStudentSurname('')
      setStudentClass('')
      setStudentNumber('')
    }
    }, [modelVisible, selectedProducts, etiketUrunId])

  const handleOk = () => {
    // Eğer öğrenci adı veya soyadı boş ise hata göster.
    if (studentName === '' || studentName === undefined || studentSurname === '' || studentSurname === undefined) {
      messageApi.warning('Lütfen öğrenci adı ve soyadını giriniz...', 4)
      return
    }

    // Seçili ürünleri güncelle
    const updatedProducts = selectedProducts.map((product: SecilenUrun) => {
      if (product.urunId === etiketUrunId) {
        return {
          ...product,
          etiket_bilgisi:
            studentName.toString() +
            '|' +
            studentSurname.toString() +
            '|' +
            studentNumber.toString() +
            '|' +
            studentClass.toString(),
        }
      }
      return product
    })

    // Güncellenmiş ürünleri setSelectedProducts ile set et
    setSelectedProducts(updatedProducts)
    setModalVisible(false)
  }

  const handleCancel = () => {
    setModalVisible(false)
  }

  const handleRefreshClick = () => {
    setStudentName('')
    setStudentSurname('')
    setStudentClass('')
    setStudentNumber('')
  }

  return (
    <Modal
      className="etiket-product-modal"
      width={1000}
      open={modelVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      title="Kitap ve Defter Etiketi"
      maskClosable={false}
      footer={
        <div className="tag-modal-size-footer">
          <Button type="primary" className="cancel" key="back" onClick={handleCancel}>
            İptal
          </Button>
          <Button key="submit" className="okey" type="primary" onClick={handleOk}>
            Tamam
          </Button>
        </div>
      }
    >
      {contextHolder}
      <div className="etiket-product">
        <Row gutter={[0, 24]}>
          <Col lg={11} md={24} sm={24} xs={24}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ position: 'relative' }}>
                <img alt="" style={{ width: '100%' }} src={defterImg} />
                <div className="absolute student-info">
                  <div className="info-item">
                    <span className="bold" id="ogrenci_isim">
                      {studentName}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="bold" id="ogrenci_soyisim">
                      {studentSurname}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="bold" id="ogrenci_sube">
                      {studentClass}
                    </span>
                    {studentNumber !== '' && (
                      <span className="bold" id="ogrenci_numara">
                        {' / ' + studentNumber}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={13} md={24} sm={24} xs={24}>
            <Row gutter={24}>
              <Col sm={12}>
                <label className="input-label" htmlFor="ogrenci_ismi_input">
                  Öğrenci Adı
                </label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Input
                    required
                    maxLength={MAX_LENGTH}
                    value={studentName}
                    onChange={(e) => setStudentName(e.target.value)}
                    name="ogrenci_ismi"
                    id="ogrenci_ismi_input"
                    suffix={<span className="remaining-span">{remainingCharsName}</span>}
                  />
                </div>
              </Col>
              <Col sm={12}>
                <label className="input-label" htmlFor="ogrenci_soyismi_input">
                  Öğrenci Soyadı
                </label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Input
                    required
                    maxLength={MAX_LENGTH}
                    value={studentSurname}
                    onChange={(e) => setStudentSurname(e.target.value)}
                    name="ogrenci_soyismi"
                    id="ogrenci_soyismi_input"
                    suffix={<span className="remaining-span">{remainingCharsSurname}</span>}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={20} className="mt-12">
              <Col md={12}>
                <label className="input-label" htmlFor="ogrenci_sinif_input">
                  Sınıfı ve Şubesi
                </label>
                <Input
                  required
                  maxLength={5}
                  value={studentClass}
                  placeholder="Sınıf ve şube belli ise giriniz"
                  onChange={(e) => setStudentClass(e.target.value)}
                  name="ogrenci_sinif"
                  id="ogrenci_sinif_input"
                  suffix={<></>}
                />
              </Col>
              <Col md={12}>
                <label className="input-label" htmlFor="ogrenci_numara_input">
                  Okul Numarası
                </label>
                <Input
                  required
                  placeholder="Okul numarası belli ise giriniz"
                  maxLength={6}
                  value={studentNumber}
                  onChange={(e) => setStudentNumber(e.target.value)}
                  name="ogrenci_numara"
                  id="ogrenci_numara_input"
                  suffix={<></>}
                />
              </Col>
            </Row>

            <Row gutter={20} className="mt-12 book-review">
              <Col className="pin-size" md={12}>
                <div className="pin-size-text">
                  <PinIcon /> Etiket Boyutu: 3x4,5 cm
                </div>{' '}
              </Col>
              <Col className="clear-button" md={12}>
                <Button onClick={() => handleRefreshClick()}>
                  <DeleteFilled /> Tümünü Temizle
                </Button>
              </Col>
            </Row>
            <Divider />
          </Col>
        </Row>
      </div>
    </Modal>
  )
}

export default ClassProductsModal
